import { render, staticRenderFns } from "./MembersTemplate.vue?vue&type=template&id=0b4bfcec&"
import script from "./MembersTemplate.vue?vue&type=script&lang=js&"
export * from "./MembersTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports